export const en = {
    accept: 'Add',
    cancel: 'Cancel',
    'error-text': 'Try again later',
    'imageAd-help-text': 'Select more than one image to create multiple ads at once',
    'textImageAd-help-text': 'Select an image for your ad',
    title: 'Gallery'
};
